import { __decorate, __extends } from "tslib";
import { BlurTask } from './tasks/BlurTask';
import { FilterBase } from './FilterBase';
import { FilterUtils, serialisable, proxyTo } from '../utils/FilterUtils';
import { Rectangle } from '@awayjs/core';
var BlurFilter = /** @class */ (function (_super) {
    __extends(BlurFilter, _super);
    function BlurFilter(props) {
        var _this = _super.call(this) || this;
        _this.imageScale = 1;
        _this._hBlurTask = new BlurTask((props === null || props === void 0 ? void 0 : props.blurX) || 4, -1, true);
        _this._vBlurTask = new BlurTask((props === null || props === void 0 ? void 0 : props.blurY) || 4, -1, false);
        _this.addTask(_this._hBlurTask);
        _this.addTask(_this._vBlurTask);
        return _this;
    }
    BlurFilter.prototype.applyProps = function (props) {
        if ('blurX' in props) {
            this.blurX = props.blurX;
        }
        if ('blurY' in props) {
            this.blurY = props.blurY;
        }
        if ('imageScale' in props) {
            this.imageScale = props.imageScale || 1;
        }
    };
    Object.defineProperty(BlurFilter.prototype, "stepSize", {
        /**
         * The distance between two blur samples. Set to -1 to autodetect with acceptable quality (default value).
         * Higher values provide better performance at the cost of reduces quality.
         */
        get: function () {
            return this._hBlurTask.stepSize;
        },
        set: function (value) {
            this._hBlurTask.stepSize = value;
            this._vBlurTask.stepSize = value;
        },
        enumerable: false,
        configurable: true
    });
    BlurFilter.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input; }
        var pad = FilterUtils.meashureBlurPad(this.blurX, this.blurY, 3, true);
        target.copyFrom(input);
        target.x -= pad.x;
        target.y -= pad.y;
        target.width += pad.x;
        target.height += pad.y;
        return target;
    };
    BlurFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManage) {
        var subPassTarget = filterManage.popTemp(source.width, source.height);
        // TEMP target can be dirty, because we use offset, clear it
        this._hBlurTask.needClear = true;
        // we not cut region, because in this case blur will emit invalid data on edge
        this._hBlurTask.inputRect.setTo(0, 0, source.width, source.height);
        // apply padding
        this._hBlurTask.destRect.setTo(0, 0, source.width, source.height);
        // but we can use a clip to kill non-used
        this._vBlurTask.clipRect = new Rectangle(0, 0, source.width, source.height);
        this._hBlurTask.clipRect = this._vBlurTask.clipRect;
        // emit real
        // crop a dest rectanle
        this._vBlurTask.inputRect.copyFrom(outRect);
        this._vBlurTask.destRect.copyFrom(outRect);
        this._hBlurTask.source = source;
        this._hBlurTask.target = subPassTarget;
        this._vBlurTask.source = subPassTarget;
        this._vBlurTask.target = target;
        this._temp = [subPassTarget];
    };
    BlurFilter.filterName = 'blur';
    __decorate([
        serialisable
    ], BlurFilter.prototype, "imageScale", void 0);
    __decorate([
        serialisable,
        proxyTo('_hBlurTask', 'amount')
    ], BlurFilter.prototype, "blurX", void 0);
    __decorate([
        serialisable,
        proxyTo('_vBlurTask', 'amount')
    ], BlurFilter.prototype, "blurY", void 0);
    return BlurFilter;
}(FilterBase));
export { BlurFilter };
